import { render, staticRenderFns } from "./BatchImportModal.vue?vue&type=template&id=063e7a3f&"
import script from "./BatchImportModal.vue?vue&type=script&lang=js&"
export * from "./BatchImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports